import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { of } from 'rxjs';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class WpapiService {

    // Endpoints
    homeurl = environment.homeurl;
    workurl = environment.workurl;
    mainUrl = environment.mainUrl;
    menuurl = environment.menuurl;


    // Observable cache
    home_categories;
    home_categories_observable;
    categories;
    categories_observable;
    page_home;
    page_home_observable;
    home_reels;
    home_reels_observable;
    home_articles;
    home_articles_observable;
    company_page;
    company_page_observable;
    reels;
    reels_page_observable;
    reels_page;
    reels_observable;
    works_item;
    workobeservable;
    works_item_related;
    works_item_related_obeservable;
    page_works;
    page_works_observable;
    main_menu;
    main_menu_obeservable;
    social_menu;
    social_menu_obeservable;
    page_footer;
    page_footer_observable;
    page_header;
    page_header_observable;
    page_instagram;
    page_instagram_observable;

    constructor(private http: HttpClient) { }

    homeCategories() {
        if (this.home_categories) {
            return of(this.home_categories);
        } else if (this.home_categories_observable) {
            return this.home_categories_observable;
        } else {
            this.home_categories_observable = this.http.get(this.homeurl + 'categories-with-random-post', {
                observe: 'response'
            }).map(response => {
                this.home_categories_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.home_categories = response.body;
                    return this.home_categories;
                }
            }).share();
            return this.home_categories_observable;
        }
    }

    // Get Home page
    getHome() {
        if (this.page_home) {
            return of(this.page_home);
        } else if (this.page_home_observable) {
            return this.page_home_observable;
        } else {
            this.page_home_observable = this.http.get(this.mainUrl + 'pages?slug=home', {
                observe: 'response'
            }).map(response => {
                this.page_home_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.page_home = response.body;
                    return this.page_home;
                }
            }).share();
            return this.page_home_observable;
        }
    }

    // Get Wroks page
    getWorksPage() {
        if (this.page_works) {
            return of(this.page_works);
        } else if (this.page_works_observable) {
            return this.page_works_observable;
        } else {
            this.page_works_observable = this.http.get(this.mainUrl + 'pages?slug=works', {
                observe: 'response'
            }).map(response => {
                this.page_works_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.page_works = response.body;
                    return this.page_works;
                }
            }).share();
            return this.page_works_observable;
        }
    }

    // Get Company page
    getCompany() {
        if (this.company_page) {
            return of(this.company_page);
        } else if (this.company_page_observable) {
            return this.company_page_observable;
        } else {
            this.company_page_observable = this.http.get(this.mainUrl + 'pages?slug=company', {
                observe: 'response'
            }).map(response => {
                this.company_page_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.company_page = response.body;
                    return this.company_page;
                }
            }).share();
            return this.company_page_observable;
        }
    }

    getWorks() {
        if (this.works_item) {
            return of(this.works_item);
        } else if (this.workobeservable) {
            return this.workobeservable;
        } else {
            this.workobeservable = this.http.get(this.mainUrl + 'works?per_page=100', {
                observe: 'response'
            }).map(response => {
                this.workobeservable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.works_item = response.body;
                    return this.works_item;
                }
            }).share();
            return this.workobeservable;
        }
    }

    getRelatedWorks() {
        if (this.works_item_related) {
            return of(this.works_item_related);
        } else if (this.works_item_related_obeservable) {
            return this.works_item_related_obeservable;
        } else {
            this.works_item_related_obeservable = this.http.get(this.mainUrl + 'works?per_page=100', {
                observe: 'response'
            }).map(response => {
                this.works_item_related_obeservable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {

                    this.works_item_related = response.body;
                    return this.works_item_related;
                }
            }).share();
            return this.works_item_related_obeservable;
        }
    }

    getArticles() {
        if (this.home_articles) {
            return of(this.home_articles);
        } else if (this.home_articles_observable) {
            return this.home_articles_observable;
        } else {
            this.home_articles_observable = this.http.get(this.mainUrl + 'articles?per_page=5', {
                observe: 'response'
            }).map(response => {
                this.home_articles_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.home_articles = response.body;
                    return this.home_articles;
                }
            }).share();
            return this.home_articles_observable;
        }
    }

    getReels() {
        if (this.reels) {
            return of(this.reels);
        } else if (this.reels_observable) {
            return this.reels_observable;
        } else {
            this.reels_observable = this.http.get(this.mainUrl + 'reels', {
                observe: 'response'
            }).map(response => {
                this.reels_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.reels = response.body;
                    return this.reels;
                }
            }).share();
            return this.reels_observable;
        }
    }

    getCatgories() {
        if (this.categories) {
            return of(this.categories);
        } else if (this.categories_observable) {
            return this.categories_observable;
        } else {
            this.categories_observable = this.http.get(this.mainUrl + 'work_categories', {
                observe: 'response'
            }).map(response => {
                this.categories_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.categories = response.body;
                    return this.categories;
                }
            }).share();
            return this.categories_observable;
        }
    }

    getReelPage() {
        if (this.reels_page) {
            return of(this.reels_page);
        } else if (this.reels_page_observable) {
            return this.reels_page_observable;
        } else {
            this.reels_page_observable = this.http.get(this.mainUrl + 'pages?slug=reels', {
                observe: 'response'
            }).map(response => {
                this.reels_page_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.reels_page = response.body;
                    return this.reels_page;
                }
            }).share();
            return this.reels_page_observable;
        }
    }

    getWorksItem(slug: string) {
        return this.http.get(this.mainUrl + 'works?slug=' + slug);
    }

    getContactInfo() {
        return this.http.get(this.mainUrl + 'pages?slug=contact');
    }

    getSocialMenu() {
        if (this.social_menu) {
            return of(this.social_menu);
        } else if (this.social_menu_obeservable) {
            return this.social_menu_obeservable;
        } else {
            this.social_menu_obeservable = this.http.get(this.menuurl + 'social-menu', {
                observe: 'response'
            }).map(response => {
                this.social_menu_obeservable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.social_menu = response.body;
                    return this.social_menu;
                }
            }).share();
            return this.social_menu_obeservable;
        }
    }

    getMainMenu() {
        if (this.main_menu) {
            return of(this.main_menu);
        } else if (this.main_menu_obeservable) {
            return this.main_menu_obeservable;
        } else {
            this.main_menu_obeservable = this.http.get(this.menuurl + 'main-menu', {
                observe: 'response'
            }).map(response => {
                this.main_menu_obeservable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.main_menu = response.body;
                    return this.main_menu;
                }
            }).share();
            return this.main_menu_obeservable;
        }
    }

    getHeader() {
        if (this.page_header) {
            return of(this.page_header);
        } else if (this.page_header_observable) {
            return this.page_header_observable;
        } else {
            this.page_header_observable = this.http.get(this.mainUrl + 'pages?slug=header', {
                observe: 'response'
            }).map(response => {
                this.page_header_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.page_header = response.body;
                    return this.page_header;
                }
            }).share();
            return this.page_header_observable;
        }
    }

    getFooter() {
        if (this.page_footer) {
            return of(this.page_footer);
        } else if (this.page_footer_observable) {
            return this.page_footer_observable;
        } else {
            this.page_footer_observable = this.http.get(this.mainUrl + 'pages?slug=footer', {
                observe: 'response'
            }).map(response => {
                this.page_footer_observable = null;
                if (response.status === 400) {
                    return 'Request failed.';
                } else if (response.status === 200) {
                    this.page_footer = response.body;
                    return this.page_footer;
                }
            }).share();
            return this.page_footer_observable;
        }
    }
}
